import Controller from '@ember/controller';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { USER_ENGAGEMENT_ELEMENT_IDS } from 'lumen/models/seen-user-engagement-element';
import type MarketSettingsCurrencyConversionIndexRoute from 'lumen/routes/market/settings/currency-conversion/index';
import type { ModelFrom } from 'lumen/utils/routes';

export default class MarketSettingsCurrencyConversionIndexController extends Controller {
  declare model: ModelFrom<MarketSettingsCurrencyConversionIndexRoute>;

  queryParams = ['profileNotFound'];
  @service declare access: Services['access'];
  @service declare userEngagement: Services['user-engagement'];
  @tracked isBannerDismissed = false;
  @tracked profileNotFound: boolean = false;

  get isReadOnly(): boolean {
    return !this.access.hasCurrencyConversionEditAccess;
  }

  get showProfileNotFoundModal(): boolean {
    return this.profileNotFound === true;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get showUserOnboardingModal() {
    return !this.userEngagement.hasSeen(
      USER_ENGAGEMENT_ELEMENT_IDS.MARKET_CURRENCY_CONVERSION_ONBOARDING_MODAL,
    );
  }

  @action
  closeProfileNotFoundModal(): void {
    this.profileNotFound = false;
  }

  @action
  closeUserOnboardingModal(): void {
    this.userEngagement.markAsSeen(
      USER_ENGAGEMENT_ELEMENT_IDS.MARKET_CURRENCY_CONVERSION_ONBOARDING_MODAL,
    );
  }

  @action
  dismissBanner(): void {
    this.isBannerDismissed = true;
  }
}
